<div>
    <span class="ion-color-warning" *ngIf="file?.validated === false"> <small>attesa verifica</small></span>

    <button *ngIf="file?.validated ===false" class="doc-status warning"></button>
    <button *ngIf="!file" class="doc-status fail"></button>
    <button *ngIf="file" class="doc-status success" (click)="openFile()"></button>


    <button class="doc-icon upload" (click)="selectFile($event)">
        <input type="file" [hidden]="true" [name]="name" (change)="uploadFile($event)"/>
    </button>

    <div *ngIf="(percentageVal.value )  && percentageVal.value > 0 &&  percentageVal.value !== 1">
        Progress: {{  percentageVal.value * 100 | number }}%
        <ion-progress-bar value="{{  percentageVal.value }}"></ion-progress-bar>
    </div>


</div>